const { MAIN } = require('../../../../common/js/constants/cookies');
const { cookieValues } = require('../../../../common/js/universal/ecosia-user');
const { COOKIES_LIST } = require('../constants');
const { getNonEssentialValuesOf } = require('../cookies-get');

const resetBasedOnConsent = (consent, cookieString) => {
  let newCookieString = cookieString || '';
  const nonEssentialValues = getNonEssentialValuesOf(MAIN);

  const mainCookie = COOKIES_LIST.find((item) => item.name === MAIN);

  nonEssentialValues.forEach((value) => {
    const valueConsent = mainCookie.permissions[value];

    if (!consent.includes(valueConsent)) {
      const cookieValue = cookieValues[value];
      const cookieDefault = cookieValue.default;

      const regex = new RegExp(`${cookieValue.key}=[^:]*`, 'g');
      if (cookieDefault === null) {
        newCookieString = newCookieString
          .replace(regex, '');
        newCookieString = newCookieString.replace(/:$/, '');
      } else {
        newCookieString = newCookieString
          .replace(regex, `${cookieValue.key}=${cookieValue.default}`);
      }
    }
  });

  return newCookieString;
};

module.exports = resetBasedOnConsent;
